var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._g(_vm._b({attrs:{"label":_vm.label == null ? _vm.$t('keywords.authentication.ws_type') : _vm.label,"items":_vm.wsAuthenticationTypes}},'v-select',{..._vm.$attrs, ..._vm.$props},false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }